var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 10 10",
    fill: "#3A92E5",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#plus_link_svg__clip0_860_1310)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.75.75v3.5h3.5c.41 0 .75.34.75.75s-.34.75-.75.75h-3.5v3.5c0 .41-.34.75-.75.75s-.75-.34-.75-.75v-3.5H.75C.34 5.75 0 5.41 0 5s.34-.75.75-.75h3.5V.75C4.25.34 4.59 0 5 0s.75.34.75.75z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "plus_link_svg__clip0_860_1310"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h10v10H0z"
  })))));
}
export default SvgPlusLink;